// src/index.js or src/App.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';




const domain = "jamesp.eu.auth0.com";
const clientId = "0oicrEjx97IiDOlRXFuTgC37P3jo6B7D";
const audience = "https://your-api-endpoint";
const redirectUri = "https://admin.sevis.click";
const scopes = "openid profile create:tenants users:read admin:read:users:all delete:tenants email"

ReactDOM.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: audience,
      scope: scopes, // The scopes your application will request
    }}
  >
    <App />
  </Auth0Provider>,
  document.getElementById('root')
);
